// One dynamic import per locale, so a bundler emits each locale as its own
// chunk and a client fetches only the languages it uses. The web SPA loads
// through this (src/lib/i18n.js); mobile apps keep the static `resources`
// export from the package root.
import type { Language } from './rtl';

type LocaleModule = { default: Record<string, unknown> };

export const localeLoaders: Record<Language, () => Promise<LocaleModule>> = {
  en: () => import('./locales/en.json'),
  ar: () => import('./locales/ar.json'),
  ckb: () => import('./locales/ckb.json'),
};
